import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class Slider {
  constructor(element) {
    if (!element) {
      return;
    }

    this.element = element;

    const options = {
      modules: [Navigation, Pagination],
      spaceBetween: 18,
    };
    if (this.element.dataset.slidesPerView) {
      const maxSlidesPerView = Number(this.element.dataset.slidesPerView);
      options.slidesPerView = 1;
      if (maxSlidesPerView > 1) {
        options.breakpoints = {
          // when window width is >= 768px
          768: {
            slidesPerView: maxSlidesPerView > 2 ? 2 : maxSlidesPerView,
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: maxSlidesPerView,
          },
        }
      }
    }
    if (this.element.dataset.pagination) {
      switch (this.element.dataset.pagination) {
        case 'true':
          options.pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          };
      }
    }
    if (this.element.dataset.autoLoop) {
      switch (this.element.dataset.pagination) {
        case 'false':
          options.loop = false;
          break;
      }
    }

    this.swiper = new Swiper(this.element, options);
  }
};
